<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-divider></v-divider>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="showAddCustomerDialog" color="primary float-right"
            >Cari Ekle</v-btn
          >
          <!-- Kullanıcı Ekle Butonu -->
        </v-col>
      </v-row>

      <CustomerForm
        v-model="addCustomerDialog"
        :newCustomer="newCustomer"
        @updateCustomer="updateCustomer"
        @closeDialog="addCustomerDialog = false"
        @fetchCustomerList="fetchCustomerList" 
      />
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="customerList"
            :items-per-page="10"
            class="elevation-1"
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Cari Listesi</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Ara..."
                  class="mx-4"
                  solo
                  clearable
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td class="text-start" style="width: 20%">
                  {{ item.fullname }}
                </td>
                <td style="width: 20%">{{ item.email }}</td>
                <td style="width: 20%">{{ item.phone }}</td>
                <td style="width: 20%">{{ item.type }}</td>
                <td class="text-end" style="width: 20%">
                  <v-btn
                    size="30"
                    @click="deleteCustomer(item.id)"
                    color="orange"
                    class="icon-size"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-delete</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                  <v-btn
                    size="30"
                    @click="editCustomer(item.id)"
                    color="orange"
                    class="icon-size ml-3"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-pencil</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
import { mapState } from "vuex";

import customerService from "@/services/customerService";
import MainLayout from "@/layouts/MainLayout.vue";
import Swal from "sweetalert2"; // SweetAlert2'yi içe aktar
import CustomerForm from "@/components/CustomerForm.vue";

export default {
  name: "CustomerList",
  components: {
    MainLayout,
    CustomerForm,
  },
  created() {
    this.fetchCustomerList();
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Cari İşlemleri",
          disabled: false,
          href: "",
        },
      ],
      newCustomer: {
        fullname: "",
        email: "",
        phone: "",
        country: "Türkiye",
        city: "",
        state: "",
        type: null,
        company: "",
        iban: "",
        tax_number: "",
        tax_office: "",
        description: "",
        address: "",
      },
      headers: [
        { title: "Adı Soyadı", value: "fullname" },
        { title: "Telefon", value: "phone" },
        { title: "Email", value: "email" },
        { title: "Tip", value: "type" },
        { title: "İşlemler", value: "actions", sortable: false, align: "end" }, // Aksiyonlar için
      ],
      select: { name: "Seçiniz", id: "0" },
      customerList: [],
      loading: false, // Yükleniyor durumu
      search: "", // Arama metni
    };
  },

  computed: {
    ...mapState(["customerList"]), // Vuex state'inden Customer'ı al
  },
  methods: {
    resetNewCustomer() {
      this.newCustomer = {
        fullname: "",
        email: "",
        phone: "",
        country: "Türkiye",
        city: "",
        state: "",
        type: null,
        company: "",
        iban: "",
        tax_number: "",
        tax_office: "",
        description: "",
        address: "",
      };
    },
    showAddCustomerDialog() {
      this.resetNewCustomer(); // Formu sıfırla
      this.addCustomerDialog = true; // Modalı göster
    },

    fetchCustomerList() {
      this.loading = true; // Yükleniyor durumunu başlat
      customerService
        .customerList()
        .then((response) => {
          console.log(response);
          this.customerList = response; // Kullanıcı listesini güncelle
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false; // Yükleniyor durumunu bitir
        });
    },
    async editCustomer(CustomerId) {
      // Kullanıcı bilgilerini al
      const CustomerToEdit = this.customerList.find(
        (Customer) => Customer.id === CustomerId
      );
      if (CustomerToEdit) {
        this.newCustomer = {
          ...CustomerToEdit,
        }; // Kullanıcı bilgilerini form alanlarına doldur
        this.addCustomerDialog = true; // Modalı aç
      }
    },
    updateCustomer(customer) {
      this.newCustomer = customer; // Güncellenmiş müşteri bilgilerini al
    },
  },

  async deleteCustomer(CustomerId) {
    const { value: confirmDelete } = await Swal.fire({
      title: "Silmek istediğinize emin misiniz?",
      text: "Bu işlem geri alınamaz!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet, sil!",
      cancelButtonText: "Hayır, iptal et!",
    });

    if (confirmDelete) {
      try {
        await customerService.deleteCustomer(CustomerId); // Kullanıcıyı silmek için servisi çağır
        this.fetchCustomerList(); // Kullanıcı listesini güncelle
        Swal.fire("Silindi!", "Kullanıcı başarıyla silindi.", "success");
      } catch (error) {
        console.error("Kullanıcı silinirken hata oluştu:", error);
        Swal.fire("Hata!", "Kullanıcı silinirken bir hata oluştu.", "error");
      }
    } else {
      Swal.fire("İptal edildi", "Kullanıcı silme işlemi iptal edildi.", "info");
    }
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
